import { environment } from '../../environments/environment';
import { ImagePreset, ImageUrlType } from '../models/image.models';

export class ImageUtils {
  static getProductImageUrl(product: any, preset?: ImagePreset, type: ImageUrlType = ImageUrlType.Small): string {
    const baseUrl: string = this.extractImageUrl(product, type);
    return preset ? this.addPreset(baseUrl, preset) : baseUrl;
  }

  private static extractImageUrl(product: any, type?: ImageUrlType): string {
    if (!product.attributes?.imageSets?.length) {
      return environment.defaultImg;
    }
    const urlType: ImageUrlType = type === ImageUrlType.Large ? ImageUrlType.Large : ImageUrlType.Small;
    return product.attributes.imageSets[0].images[0][urlType];
  }

  static addPreset(url: string, preset: ImagePreset): string {
    try {
      if (!url) {
        return this.addPreset(environment.defaultImg, preset);
      }
      const urlObj: URL = new URL(url);
      urlObj.searchParams.set('preset', preset);
      return urlObj.toString();
    } catch {
      return this.addPreset(environment.defaultImg, preset);
    }
  }
}
